import { authSlice } from '@wellesley/auth/authSlice'
import { useSelector } from 'react-redux'
import { userSlice } from '../slices/userSlice'

export const useCurrentUser = () => {
  const user = useSelector(userSlice.selectors.selectCurrentUser)
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)
  const isLoading = useSelector(userSlice.selectors.selectPending)
  const error = useSelector(userSlice.selectors.selectError)

  return { user, isLoading, isLogged, error }
}

export default useCurrentUser
